class VideoObserver {
  constructor() {
    this.video = null;
    this.observer = null;
    this.options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    };
  }

  init() {
    document
      .querySelector('.video-section__poster')
      .addEventListener('click', () => {
        setTimeout(() => {
          this.video = document.querySelector('#myVideo');
          if (this.video) {
            this.createObserver();
          }
        }, 500);
      });
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.callback, this.options);
    this.observer.observe(this.video);
  }

  callback(entries) {
    entries.forEach((entry) => {
      if (entry.target.classList.contains('video')) {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      } else if (entry.target.classList.contains('js-youtube')) {
        if (entry.isIntersecting) {
          entry.target.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            '*'
          );
        } else {
          entry.target.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        }
      } else if (entry.target.classList.contains('js-vimeo')) {
        if (entry.isIntersecting) {
          entry.target.contentWindow.postMessage({ method: 'play' }, '*');
        } else {
          entry.target.contentWindow.postMessage({ method: 'pause' }, '*');
        }
      }
    });
  }
}
const videoObserver = new VideoObserver();
videoObserver.init();
